import { render } from "./index.vue?vue&type=template&id=3ce4d0e1"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/home/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ce4d0e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ce4d0e1', __exports__)) {
    console.log('reload')
    api.reload('3ce4d0e1', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3ce4d0e1", () => {
    console.log('re-render')
    api.rerender('3ce4d0e1', render)
  })

}


export default __exports__